import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const { connected } = useSelector((store) => store.user);
  if (!connected) {
    return <Navigate to='/landing' />;
  }
  return children;
};
export default ProtectedRoute;
